export const searchInput = {
  stringOptions: {
    include_match: "部分一致",
    match: "完全一致",
    forward_match: "前方一致",
    backward_match: "後方一致",
  },
};
